import { CommonModule, formatDate } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { MenuItem, MessageService } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { TagModule } from 'primeng/tag';
import { ToastModule } from 'primeng/toast';
import { PageDataPanelComponent } from '../../../../shared/page-layout/page-data-panel.component';
import { PageDetailHeroComponent } from '../../../../shared/page-layout/page-detail-hero.component';
import { PageMetricStripComponent } from '../../../../shared/page-layout/page-metric-strip.component';
import { PageMetric } from '../../../../shared/page-layout/page-layout.models';
import { PageShellComponent } from '../../../../shared/page-layout/page-shell.component';
import { MobilizationSalaryRule } from '../../models/mobilization.model';
import { MobilizationService } from '../../mobilization.service';

@Component({
    selector: 'app-salary-rule-view',
    standalone: true,
    templateUrl: './salary-rule-view.component.html',
    styleUrls: ['../salary-rule-page.css'],
    imports: [
        CommonModule,
        RouterModule,
        BreadcrumbModule,
        ButtonModule,
        TagModule,
        ToastModule,
        PageShellComponent,
        PageDetailHeroComponent,
        PageMetricStripComponent,
        PageDataPanelComponent
    ]
})
export class SalaryRuleViewComponent implements OnInit {
    breadcrumbItems: MenuItem[] = [];
    homeBreadcrumb: MenuItem = { icon: 'pi pi-home', routerLink: '/' };
    salaryRuleId = 0;
    rule?: MobilizationSalaryRule;
    isLoading = false;

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private mobilizationService: MobilizationService,
        private messageService: MessageService
    ) {}

    ngOnInit(): void {
        this.salaryRuleId = Number(this.route.snapshot.paramMap.get('id'));
        this.breadcrumbItems = [
            { label: 'Fleet', routerLink: '/fleet' },
            { label: 'Mobilization', routerLink: '/fleet/mobilization' },
            { label: 'Salary Rules', routerLink: '/fleet/mobilization/salary-rules' },
            { label: 'View' }
        ];
        if (this.salaryRuleId) {
            this.load();
        }
    }

    load(): void {
        this.isLoading = true;
        this.mobilizationService.getSalaryRule(this.salaryRuleId).subscribe({
            next: response => {
                this.rule = response.data;
                this.isLoading = false;
            },
            error: () => {
                this.isLoading = false;
                this.messageService.add({ severity: 'error', summary: 'Load failed', detail: 'Could not load salary rule.' });
            }
        });
    }

    edit(): void {
        this.router.navigate(['/fleet/mobilization/salary-rules/edit', this.salaryRuleId]);
    }

    back(): void {
        this.router.navigate(['/fleet/mobilization/salary-rules']);
    }

    metrics(): PageMetric[] {
        return [
            { label: 'Daily Rate', value: `${this.rule?.dailyRate ?? 0} ${this.rule?.currencyCode || 'SAR'}`, hint: 'Base daily salary', tone: 'info' },
            { label: 'Status', value: this.rule?.active === false ? 'Inactive' : 'Active', hint: 'Rule availability', tone: this.rule?.active === false ? 'danger' : 'success' },
            { label: 'Priority', value: this.rule?.priority ?? 0, hint: 'Higher priority wins', tone: 'warn' },
            { label: 'Truck Type', value: this.rule?.vehicleTypeName || '-', hint: 'Matching vehicle type', tone: 'default' }
        ];
    }

    activeSeverity(active?: boolean): 'success' | 'danger' {
        return active === false ? 'danger' : 'success';
    }

    dateLabel(value?: string | Date): string {
        return value ? formatDate(value, 'MMM d, y', 'en-US') : '-';
    }
}
